import { render, staticRenderFns } from "./returnForm.vue?vue&type=template&id=ea28fe1e"
import script from "./returnForm.vue?vue&type=script&lang=js"
export * from "./returnForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports